import React, { useEffect } from 'react';
import cx from 'classnames';

import { Button, Label, Loader } from '@atlas/ui';

import { debounce } from 'common/utils/debounce';

const LuckyDayDescription = ({ children, handleShowMore, isShowMore, winnersList }) => {
  const [screenWidth, setScreenWidth] = React.useState(null);
  const [sliceWinnersList, setSliceWinnersList] = React.useState([]);

  const colAmount = Math.floor(screenWidth / 100);

  const isVisibleBtn = colAmount < winnersList?.length;

  const isHiddenBorder = index => index % colAmount === 0 && 'hidden-border';

  const throttledScreenWidth = debounce(() => setScreenWidth(window.screen.width), 1000);

  const handleResize = () => throttledScreenWidth();

  useEffect(() => {
    if (!winnersList) return;

    if (!isShowMore) {
      setSliceWinnersList(winnersList.slice(0, colAmount));
      return;
    }

    setSliceWinnersList(winnersList);
  }, [winnersList, isShowMore, colAmount]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const RenderList = () => {
    if (!winnersList)
      return (
        <div className="luckyday-winners__loader">
          <Loader />
        </div>
      );

    if (winnersList && !winnersList.length) {
      return (
        <div className="luckyday-winners__loader luckyday-winners__empty">
          <Label className="luckyday-winners__empty__title" message="empty_today_winners" />
          <Label
            className="luckyday-winners__empty__subtitle"
            message="empty_today_winners_subtitle"
          />
        </div>
      );
    }

    return (
      <>
        <div className="luckyday-winners__list">
          {sliceWinnersList.map((col, index) => (
            <div
              className={cx('luckyday-winners__col', isHiddenBorder(index))}
              key={`${index}-${col[index]}`}
            >
              {col.map(id => (
                <div className="luckyday-winners__item" id={id} key={id}>
                  {id}
                </div>
              ))}
            </div>
          ))}
        </div>

        {isVisibleBtn && (
          <Button
            label={isShowMore ? 'read_less' : 'read_more'}
            onClick={handleShowMore}
            size="medium"
            type="secondary"
          />
        )}
      </>
    );
  };

  return (
    <div className="tournaments-box tournaments-box_winners">
      <div className="luckyday-winners">
        {children}

        <RenderList />
      </div>
    </div>
  );
};

export default LuckyDayDescription;
